<template>
	<PageContainer title="Ações dos Usuários">
		<Box class="actions-container" space="medium">
			<div class="header">
				<Search legend="Procurar usuário" placeholder="Insira o nome do usuário" :disabled="loading"
					@submit:search="submitSearch" />
			</div>

			<div v-if="loading" class="d-flex justify-content-center">
				<component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
				</component>
			</div>

			<div v-else-if="usersActions.length > 0 && !loading" class="table-container">
				<Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
					@page-changed="fetchUsuariosActions" />

				<Table :headers="['Nome', 'IP', 'Navegador', 'Ação', 'Módulo', 'Data']">
					<tr v-for="usersAction in usersActions" :key="usersActions.id_log_usuario">
						<td>{{ usersAction.nome }}</td>
						<td>{{ usersAction.ip }}</td>
						<td>{{ usersAction.navegador }}</td>
						<td>{{ usersAction.acao_log_sistema }}</td>
						<td>{{ usersAction.modulo }}</td>
						<td>{{ utils.formatDate(usersAction.created_at) }}</td>
					</tr>
				</Table>
			</div>
		</Box>
	</PageContainer>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import utils from '../../services/utils'
import PageContainer from '../core/PageContainer'
import Box from '../core/Box'
import Search from '../core/Search'
import Table from '../core/Table'
import Paginate from '../core/Paginate'

export default {
	name: 'TableSalas',
	components: {
		...spinners,

		PageContainer,
		Box,
		Search,
		Table,
		Paginate,
	},
	data() {
		return {
			utils: utils,
			paginationData: {
				currentPage: 1,
				lastPage: 0,
				total: 0,
			},
			filters: null,
			usersActions: [],
			loading: false,
		}
	},
	async created() {
		await this.fetchUsuariosActions()
	},
	methods: {
		async fetchUsuariosActions(page = 1) {
			this.loading = true

			const params = {
				page,
			}

			if (this.search) {
				params.search = this.search
			}

			this.filters = params

			await this.$http.get(`${urlApi}/logs/usuarios`, {
				params,
			})
				.then(response => {
					const data = response.body

					this.usersActions = data.data

					if (this.usersActions.length < 1) {
						this.toast('Sem resultados para sua pesquisa!')
					}

					this.paginationData = {
						currentPage: data.current_page,
						lastPage: data.last_page,
						total: data.total,
					}
				})
				.catch(err => {
					this.toast('Erro ao buscar ações dos usuários.')
				})
				.finally(() => {
					this.loading = false
				})
		},
		async submitSearch(e) {
			this.search = e

			await this.fetchUsuariosActions()
		},
		toast(text) {
			this.$toasted.show(text, {
				icon: 'fa-times',
				position: 'top-right',
				duration: 5000,
				fullWidth: false
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.actions-container {
	display: flex;
	flex-direction: column;
	gap: 2rem;

	.header {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: flex-end;
		gap: 1.5rem;

		form {
			flex: 1;
			max-width: 24.125rem;
		}
	}

	.table-container {
		display: flex;
		flex-direction: column;
		gap: 1rem;

		.pagination-container {
			align-self: flex-end;
		}
	}
}
</style>
